import HeadlineItem, { type HeadlineToken } from './HeadlineItem';

const MOCK_HEADLINE_TOKENS: HeadlineToken[] = [
  { symbol: 'BONK', address: 'DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263' },
  { symbol: 'WIF', address: 'EKpQGSJtjMFqKZ9KQanSqYXRcF8fBopzLHYxdM65zcjm' },
  { symbol: 'POPCAT', address: '7GCihgDB8fe6KNjn2MYtkzZcRjQy3t9GHdC8uHYmW2hr' },
  { symbol: 'JUP', address: 'JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN' },
  { symbol: 'PYTH', address: 'HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3' },
  { symbol: 'RAY', address: '4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R' },
  { symbol: 'ORCA', address: 'orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE' },
  { symbol: 'MNGO', address: 'MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac' },
];

interface HeadlineTickerProps {
  tokens?: HeadlineToken[];
  onTokenClick?: (address: string) => void;
}

export default function HeadlineTicker({ tokens = MOCK_HEADLINE_TOKENS, onTokenClick }: HeadlineTickerProps) {
  const list = tokens.length > 0 ? tokens : MOCK_HEADLINE_TOKENS;

  return (
    <div className="headline-ticker-wrap">
      <div className="headline-ticker-track">
        <div className="headline-ticker-inner">
          {list.map((token, i) => (
            <HeadlineItem key={`${token.address}-${i}`} token={token} onSelect={onTokenClick} />
          ))}
          {list.map((token, i) => (
            <HeadlineItem key={`${token.address}-dup-${i}`} token={token} onSelect={onTokenClick} />
          ))}
        </div>
      </div>
    </div>
  );
}
